import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
//import ContextualBalloon from "@ckeditor/ckeditor5-ui";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import FullScreen from "@/components/ckeditor/fullScreen";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage";
import ListProperties from '@ckeditor/ckeditor5-list/src/listproperties';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting";
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import SimpleUploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter";
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import List from '@ckeditor/ckeditor5-list/src/list';
import Font from '@ckeditor/ckeditor5-font/src/font';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import ExtendHtmlSupport from "./ckeditor/ExtendHtmlSupport";
import VueLink from "./ckeditor/VueLink/VueLinkUI";
const Editors = {
    Default: {
        type: ClassicEditor,
        config: {
            plugins: [
                EssentialsPlugin,
                BoldPlugin,
                Subscript,
                Superscript,
                FullScreen,
                ItalicPlugin,
                LinkPlugin,
                ParagraphPlugin,
                HeadingPlugin,
                ExtendHtmlSupport,
                VueLink,
                SourceEditing,
                Indent,
                IndentBlock,
                Image,
                ImageCaption,
                ImageStyle,
                ImageToolbar,
                ImageUpload,
                ImageResize,
                LinkImage,
                SimpleUploadAdapter,
                Alignment,
                List,
                ListProperties,
                Font,
                RemoveFormat,
                Table,
                TableToolbar,
            ],
            toolbar: {
                items: ["heading", "|", "fontFamily", "fontSize", "fontColor", "fontBackgroundColor", "alignment", "bold", "italic", "vueLink", "|", "subscript", "superscript", "insertTable", "bulletedList", "numberedList", "outdent", "indent", "|", "uploadImage", "undo", "redo", "removeFormat", "|", "sourceEditing", "fullScreen",],
                shouldNotGroupWhenFull: true
            },
            image: {
                toolbar: [
                    'linkImage',
                    //'imageTextAlternative',
                    'toggleImageCaption',
                    '|',
                    'imageStyle:alignLeft',
                    'imageStyle:block',
                    'imageStyle:alignRight'
                ]
            },
            list: {
                property: {
                    styles: true,
                    startIndex: false,
                    reversed: false
                }
            },
            table: {
                contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
            },
            simpleUpload: {
                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/simple-upload-adapter.html
                uploadUrl: process.env.VUE_APP_API + "api/v2/cms/upload",
            },
            fontColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            fontBackgroundColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            link: {
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: 'Open in a new tab',
                        defaultValue: true,
                        attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    }
                }
            },
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        styles: true,
                        classes: true,
                        attributes: true
                    }
                ],
                disallow: [
                    {
                        name: /wc-.*/
                    }
                ]
            }
        }
    }
};
export { Editors };
